function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconLogoutFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M18 3a2 2 0 012 2v8h-2V5H4v22h14v-8h2v8a2 2 0 01-2 2H4a2 2 0 01-2-2V5a2 2 0 012-2h14zm12 13l-7 5v-4H9v-2h14v-4l7 5z",
    fill: props.color
  }));
}

export default SvgIconLogoutFilled;